export function setupColorScheme() {
    const htmlElement = document.querySelector("html")!;
    if (htmlElement.getAttribute("data-bs-theme") === 'auto') {
        function updateTheme() {
            const mode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            document.querySelector("html")!.setAttribute("data-bs-theme",
                mode
            )
        }

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme)
        updateTheme()
    }
}